import { Navigate, useLocation } from 'react-router-dom';

// Legacy compatibility route.
// The normal workout flow now goes directly to the active workout experience.
const WorkoutPlan = () => {
  const location = useLocation();

  return (
    <Navigate
      to="/log-workout"
      replace
      state={location.state}
    />
  );
};

export default WorkoutPlan;
